<template>
  <v-card class="ma-4 pa-4">
    <progress-page v-if="state.data===null"/>
    <div v-else>
      <div class="mb-2 body-2">Базовые метрики</div>
      <v-row class="fill-height rowSmall mb-2">
        <v-col cols="auto">
          <sheet-group class="fill-height">
            <v-sheet :height="heightCard" :width="widthCard">
              <div class="mb-2 body-2 font-weight-medium">CPU</div>
              <v-row no-gutters>
                <v-col><div class="caption">Сейчас</div></v-col>
                <v-col cols="auto"><div class="caption">{{state.data.cpu.now}}%</div></v-col>
              </v-row>
              <v-progress-linear :value="state.data.cpu.now" rounded class="mb-2" />
              <v-row no-gutters>
                <v-col><div class="caption">1 минута</div></v-col>
                <v-col cols="auto"><div class="caption">{{state.data.cpu.min1}}%</div></v-col>
              </v-row>
              <v-progress-linear :value="state.data.cpu.min1" rounded class="mb-2" />
              <v-row no-gutters>
                <v-col><div class="caption">5 минут</div></v-col>
                <v-col cols="auto"><div class="caption">{{state.data.cpu.min5}}%</div></v-col>
              </v-row>
              <v-progress-linear :value="state.data.cpu.min5" rounded class="mb-2" />
              <v-row no-gutters>
                <v-col><div class="caption">15 минут</div></v-col>
                <v-col cols="auto"><div class="caption">{{state.data.cpu.min15}}%</div></v-col>
              </v-row>
              <v-progress-linear :value="state.data.cpu.min15" rounded />
            </v-sheet>
          </sheet-group>
        </v-col>
        <v-col cols="auto">
          <sheet-group class="fill-height">
            <v-sheet :height="heightCard" :width="widthCard">
              <div class="mb-2 body-2 font-weight-medium">ОЗУ</div>
              <v-row no-gutters>
                <v-col><div class="caption">Используется</div></v-col>
                <v-col cols="auto"><div class="caption">{{Math.round(state.data.memory.used/1024)}}GB</div></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col><div class="caption">Свободно</div></v-col>
                <v-col cols="auto"><div class="caption">{{Math.round(state.data.memory.free/1024)}}GB</div></v-col>
              </v-row>
              <v-row no-gutters class="mb-2">
                <v-col><div class="caption">Всего</div></v-col>
                <v-col cols="auto"><div class="caption">{{Math.round(state.data.memory.total/1024)}}GB</div></v-col>
              </v-row>
              <v-progress-linear :value="(state.data.memory.used/state.data.memory.total)*100" rounded class="mb-2" />
            </v-sheet>
          </sheet-group>
        </v-col>
        <v-col cols="auto">
          <sheet-group class="fill-height">
            <v-sheet :height="heightCard" :width="widthCard">
              <div class="mb-2 body-2 font-weight-medium">Диск</div>
              <v-row no-gutters>
                <v-col><div class="caption">Используется</div></v-col>
                <v-col cols="auto"><div class="caption">{{Math.round(state.data.hdd.used)}}GB</div></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col><div class="caption">Свободно</div></v-col>
                <v-col cols="auto"><div class="caption">{{Math.round(state.data.hdd.free)}}GB</div></v-col>
              </v-row>
              <v-row no-gutters class="mb-2">
                <v-col><div class="caption">Всего</div></v-col>
                <v-col cols="auto"><div class="caption">{{Math.round(state.data.hdd.total)}}GB</div></v-col>
              </v-row>
              <v-progress-linear :value="(state.data.hdd.used/state.data.hdd.total)*100" rounded class="mb-2" />
            </v-sheet>
          </sheet-group>
        </v-col>
      </v-row>
      <div class="mb-2 body-2">Сервисы</div>
      <v-row class="fill-height rowSmall">
        <v-col v-for="(v, k) in state.data.services" :key="k" cols="auto">
          <sheet-group class="fill-height">
            <v-sheet :height="heightCard" :width="widthCard">
              <div class="body-2 font-weight-medium">{{v.name}}</div>
              <div class="mb-2 caption muted">{{v.serviceName}}</div>
              <chip v-if="v.run" color="success" dark  class="mb-2">Работает</chip>
              <chip v-else color="error" dark  class="mb-2">Не работает</chip>
              <v-row v-if="v.run" no-gutters>
                <v-col><div class="caption">Память</div></v-col>
                <v-col cols="auto"><div class="caption">{{v.memory}}</div></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col><div class="caption">Время</div></v-col>
                <v-col cols="auto"><div class="caption">{{v.time}}</div></v-col>
              </v-row>
            </v-sheet>
          </sheet-group>
        </v-col>
      </v-row>
    </div>
  </v-card>

</template>

<script>
import SheetGroup from "@/componentsV2/base/SheetGroup.vue";
import axios from "axios";
import Api from "@/Api";
import Stater from "@/plugins/stater";
import ProgressPage from "@/components/ProgressPage.vue";
import Chip from "@/componentsV2/base/Chip.vue";

export default {
  components: {Chip, ProgressPage, SheetGroup},
  data: () => ({
    state: new Stater(),
    timer:null,
    heightCard: 170,
    widthCard: 250
  }),
  mounted() {
    this.load();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods:{
    load(){
      this.state.stateLoading()
      axios.get(Api.host + '/monitor/')
          .then((r) =>{
            this.state.data = r.data;
            this.state.stateSuccess()
            this.timer = setTimeout(this.load, 2000);
          })
    },
  }
}
</script>